import React from 'react'
import { Link } from 'react-router-dom';

import cat1 from '../images/wedding.jpg'
import cat2 from '../images/wedding2.jpg'
import cat3 from '../images/engagement.jpg'
import cat4 from '../images/birthday.jpg'



const Productcatogory = () => {
    return (



        <div className='productcatogorey'>

            <br />
            <h2 className='text-center text-white '> Majestic HOTEL CATEGORY</h2>

            <br />

            <h6 className='text-center text-white '>At Hotel Majestic Lucknow, we offer a comfortable and relaxing stay with thoughtfully designed rooms tailored to meet your needs.
            </h6>




            <div class="container">

                <div class="amenities-section">
                    <h2 class="section-title">Room Categories</h2>
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col">Room Type</th>
                                <th scope="col">Number of Rooms</th>
                                <th scope="col">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Deluxe Rooms</td>
                                <td>3</td>
                                <td>Spacious and elegantly designed rooms ideal for travelers seeking extra comfort and premium amenities.</td>
                            </tr>
                            <tr>
                                <td>Standard Rooms</td>
                                <td>40</td>
                                <td>Well-furnished rooms with modern amenities, perfect for both business and leisure travelers.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>


                <div class="amenities-section">
                    <h2 class="section-title">Our Services & Amenities</h2>
                    <p style={{ color: 'white' }}>Enjoy a hassle-free and luxurious stay with a range of services and amenities:</p>

                    <div class="row">

                        <div class="col-md-6 col-lg-4 mb-4">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">General Amenities</h5>
                                    <ul class="amenities-list">
                                        <li>Free High-Speed Wi-Fi</li>
                                        <li>Centralized Air Conditioning</li>
                                        <li>24x7 Power Backup</li>
                                        <li>Lift/Elevator Access</li>
                                        <li>Daily Housekeeping</li>
                                        <li>Round-the-Clock Room Service</li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div class="col-md-6 col-lg-4 mb-4">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Parking</h5>
                                    <ul class="amenities-list">
                                        <li>Onsite Parking for Guests</li>
                                        <li>Secure & Well-Lit Parking Area</li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div class="col-md-6 col-lg-4 mb-4">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Dining</h5>
                                    <ul class="amenities-list">
                                        <li>In-house Kitchen</li>
                                        <li>Freshly Prepared Meals on Order</li>
                                        <li>Room Service Available</li>
                                        <li>Custom Meal Options (Veg/Non-Veg)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div class="col-md-6 col-lg-4 mb-4">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Staff & Support</h5>
                                    <ul class="amenities-list">
                                        <li>Courteous and Trained Staff</li>
                                        <li>24-Hour Front Desk Support</li>
                                        <li>Professional Housekeeping Team</li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div class="col-md-6 col-lg-4 mb-4">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Safety & Security</h5>
                                    <ul class="amenities-list">
                                        <li>CCTV Surveillance in Common Areas</li>
                                        <li>Fire Safety Compliance</li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div class="col-md-6 col-lg-4 mb-4">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Business & Other Facilities</h5>
                                    <ul class="amenities-list">
                                        <li>Spacious Lobby with Seating</li>
                                        <li>Meeting Area</li>
                                        <li>Travel Desk Support (on request)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='product2'>

                <div className='product3'>
                    <img src={cat1} />
                </div>

                <div className='product3'>
                    <img src={cat2} />
                </div>

                <div className='product3'>
                    <img src={cat3} />
                </div>

                <div className='product3'>
                    <img src={cat4} />
                </div>

            </div>




            <center>   <a href='https://www.google.com/travel/hotels/Hotel%20Majestic%2C%2046%2F46A%2C%20Doodh%20Mandi%20Road%2C%20Cash%20and%20Pay%20Colony%2C%20Charbagh%2C%20Lucknow%2C%20Uttar%20Pradesh/entity/CgoI9e-Vxf6wsOJ2EAE?ts=CAESCgoCCAMKAggDEAAaIAoCGgASGhIUCgcI6Q8QBhgYEgcI6Q8QBhgZGAEyAhAAKgkKBToDSU5SGgA&utm_campaign=sharing&utm_medium=native&utm_source=htls&shem=hmpsa&sf=car&ved=0CAAQ5JsGahcKEwjQ-Zf97ouOAxUAAAAAHQAAAAAQAw' className='text-center btn btn-success'>Book Majestic Hotels</a></center>

            <br />     <br />
        </div>



    )
}

export default Productcatogory